import { HttpClientModule } from "@angular/common/http";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule, FormsModule } from "@angular/forms";
import { BrowserAnimationsModule } from "@angular/platform-browser/animations";
import { RouterModule } from "@angular/router";
import { AutoCompleteModule } from "primeng/autocomplete";
import { ButtonModule } from "primeng/button";
import { CalendarModule } from "primeng/calendar";
import { CardModule } from "primeng/card";
import { ChartModule } from "primeng/chart";
import { CheckboxModule } from "primeng/checkbox";
import { DropdownModule } from "primeng/dropdown";
import { EditorModule } from "primeng/editor";
import { InputNumberModule } from "primeng/inputnumber";
import { InputTextModule } from "primeng/inputtext";
import { InputTextareaModule } from "primeng/inputtextarea";
import { ListboxModule } from "primeng/listbox";
import { TableModule } from "primeng/table";
import { ToastModule } from "primeng/toast";
import { TreeModule } from "primeng/tree";
import { OrderListModule } from "primeng/orderlist";
import { AvatarselectorComponent } from "../components/avatarselector/avatarselector.component";
import { BannerdeleteComponent } from "../components/bannerdelete/bannerdelete.component";
import { BannereditorComponent } from "../components/bannereditor/bannereditor.component";
import { BannersComponent } from "../components/banners/banners.component";
import { CartstatisticsComponent } from "../components/cartstatistics/cartstatistics.component";
import { CartstatisticsdetailComponent } from "../components/cartstatisticsdetail/cartstatisticsdetail.component";
import { CategoriesComponent } from "../components/categories/categories.component";
import { CategorydeleteComponent } from "../components/categorydelete/categorydelete.component";
import { CategoryeditorComponent } from "../components/categoryeditor/categoryeditor.component";
import { ConfirmComponent } from "../components/confirm/confirm.component";
import { CustomereditorComponent } from "../components/customereditor/customereditor.component";
import { CustomergroupdeleteComponent } from "../components/customergroupdelete/customergroupdelete.component";
import { CustomergroupeditorComponent } from "../components/customergroupeditor/customergroupeditor.component";
import { CustomergroupsComponent } from "../components/customergroups/customergroups.component";
import { CustomersComponent } from "../components/customers/customers.component";
import { FrameComponent } from "../components/frame/frame.component";
import { HomeComponent } from "../components/home/home.component";
import { LoginComponent } from "../components/login/login.component";
import { LogoutComponent } from "../components/logout/logout.component";
import { ProductattributedeleteComponent } from "../components/productattributedelete/productattributedelete.component";
import { ProductattributeeditorComponent } from "../components/productattributeeditor/productattributeeditor.component";
import { ProductattributesComponent } from "../components/productattributes/productattributes.component";
import { ProducteditorComponent } from "../components/producteditor/producteditor.component";
import { ProductpricetypedeleteComponent } from "../components/productpricetypedelete/productpricetypedelete.component";
import { ProductpricetypeeditorComponent } from "../components/productpricetypeeditor/productpricetypeeditor.component";
import { ProductpricetypesComponent } from "../components/productpricetypes/productpricetypes.component";
import { ProductsComponent } from "../components/products/products.component";
import { UsereditorComponent } from "../components/usereditor/usereditor.component";
import { UsergroupdeleteComponent } from "../components/usergroupdelete/usergroupdelete.component";
import { UsergroupeditorComponent } from "../components/usergroupeditor/usergroupeditor.component";
import { UsergroupsComponent } from "../components/usergroups/usergroups.component";
import { UsersComponent } from "../components/users/users.component";
import { PermissionDirective } from "../directives/permission.directive";
import { SimpleCardTitleComponent } from "../generals/Components";
import { BannerActionPipe } from "../pipes/banneraction.pipe";
import { CustomerStatusPipe } from "../pipes/customerstatus.pipe";
import { FormatDateRPipe } from "../pipes/formatdater.pipe";
import { FtPipe } from "../pipes/ft.pipe";
import { ProductAttributeformatPipe } from "../pipes/productattributeformat.pipe";
import { ProductStatusPipe } from "../pipes/productstatus.pipe";
import { OrdersComponent } from "../components/orders/orders.component";
import { OrderdetailsComponent } from "../components/orderdetails/orderdetails.component";
import { AddressPipe } from "../pipes/address.pipe";
import { RoundingRulePipe } from '../pipes/roundingrule.pipe';
import { MessagesModule } from 'primeng/messages';
import { ChipsModule } from 'primeng/chips';
import { FilesComponent } from "../components/files/files.component";
import { FaqComponent } from "../components/faq/faq.component";
import { FaqEditorComponent } from "../components/faqeditor/faqeditor.component";
import { PagesComponent } from "../components/pages/pages.component";
import { PageEditorComponent } from "../components/pageeditor/pageeditor.component";
import { FaqSortComponent } from "../components/faqsort/faqsort.component";
import { BannerSortComponent } from "../components/bannersort/bannersort.component";
import { ModulesComponent } from "../components/modules/modules.component";
import { ModuleComponent } from "../components/module/module.component";
import { ModulelogComponent } from "../components/module/modulelog/modulelog.component";
import { GlobizFeedImportModuleComponent } from "../components/module/modulecomponents/globizfeedimportmodule/globizfeedimportmodule.component";
import { MailNotifierModuleComponent } from "../components/module/modulecomponents/mailnotifiermodule/mailnotifiermodule.module";
import { ProductSearchIndexerModuleComponent } from "../components/module/modulecomponents/productsearchindexermodule/productsearchindexer.module";
import { ProductPricingModuleComponent } from "../components/module/modulecomponents/productpricingmodule/productpricingmodule.component";
import { CategorySelectorModalComponent } from '../components/categoryselectormodal/categoryselectormodal.component';
import { SliderModule } from 'primeng/slider';
import { CurrenciesComponent } from "../components/currencies/currencies.component";
import { CurrencyeditorComponent } from "../components/currencyeditor/currencyeditor.component";
import { SettingsComponent } from '../components/settings/settings.component';
import { ProductImagesComponent } from "../components/productimages/productimages.component";
import { IsSuperUserDirective } from "../directives/issuperuser.directive";
import { PaymentSimplepayModuleComponent } from "../components/module/modulecomponents/paymentsimplepay/paymentsimplepay.component";
import { PaymentMethodsComponent } from "../components/paymentmethods/paymentmethods.component";
import { PaymentMethodEditorComponent } from "../components/paymentmethodeditor/paymentmethodeditor.component";
import { ShippingMethodsComponent } from "../components/shippingmethods/shippingmethods.component";
import { ShippingMethodEditorComponent } from "../components/shippingmethodeditor/shippingmethodeditor.component";
import { MultiSelectModule } from "primeng/multiselect";
import { BlogsComponent, ProductsgratisComponent } from "../../public-api";
import { ProductsgratiseditorComponent } from "../components/productsgratiseditor/productsgratiseditor.component";
import { ProductsearchComponent } from "../components/productsearch/productsearch.component";
import { FacebookCatalogModuleComponent } from "../components/module/modulecomponents/facebookcatalogmodule/facebookcatalogmodule.component";
import { BlogeditorComponent } from "../components/blogeditor/blogeditor.component";
import { BlogdeleteComponent } from "../components/blogdelete/blogdelete.component";
import { GoogleMerchantModuleComponent } from "../components/module/modulecomponents/googlemerchantmodule/googlemerchantfeedmodule.component";

@NgModule({
    declarations: [
        LoginComponent,
        HomeComponent,
        UsersComponent,
        UsergroupsComponent,
        UsereditorComponent,
        UsergroupeditorComponent,
        CategoriesComponent,
        CustomereditorComponent,
        CustomergroupsComponent,
        CustomergroupeditorComponent,
        CustomergroupdeleteComponent,
        CustomersComponent,
        UsergroupdeleteComponent,
        CustomerStatusPipe,
        CategoryeditorComponent,
        CategorydeleteComponent,
        LogoutComponent,
        FrameComponent,
        ProductattributesComponent,
        ProductattributeeditorComponent,
        ProductattributedeleteComponent,
        ProductAttributeformatPipe,
        AvatarselectorComponent,
        ProductpricetypesComponent,
        ProductpricetypedeleteComponent,
        ProductpricetypeeditorComponent,
        SimpleCardTitleComponent,
        ProducteditorComponent,
        ProductsComponent,
        ProductStatusPipe,
        ConfirmComponent,
        BannersComponent,
        BannereditorComponent,
        BannerdeleteComponent,
        BannerSortComponent,
        BannerActionPipe,
        FormatDateRPipe,
        CartstatisticsComponent,
        CartstatisticsdetailComponent,
        FtPipe,
        PermissionDirective,
        IsSuperUserDirective,
        OrdersComponent,
        OrderdetailsComponent,
        FilesComponent,
        AddressPipe,
        FaqComponent,
        FaqEditorComponent,
        FaqSortComponent,
        PagesComponent,
        PageEditorComponent,
        ModulesComponent,
        ModuleComponent,
        ModulelogComponent,
        ProductSearchIndexerModuleComponent,
        MailNotifierModuleComponent,
        GlobizFeedImportModuleComponent,
        ProductPricingModuleComponent,
        CategorySelectorModalComponent,
        FacebookCatalogModuleComponent,
        GoogleMerchantModuleComponent,
        RoundingRulePipe,
        CurrenciesComponent,
        CurrencyeditorComponent,
        SettingsComponent,
        ProductImagesComponent,
        PaymentSimplepayModuleComponent,
        PaymentMethodsComponent,
        PaymentMethodEditorComponent,
        ShippingMethodsComponent,
        ShippingMethodEditorComponent,
        ProductsgratisComponent,
        ProductsgratiseditorComponent,
        ProductsearchComponent,
        BlogsComponent,
        BlogeditorComponent,
        BlogdeleteComponent
    ],
    imports: [
        InputTextModule,
        TableModule,
        HttpClientModule,
        ReactiveFormsModule,
        CheckboxModule,
        ButtonModule,
        BrowserAnimationsModule,
        ListboxModule,
        FormsModule,
        CardModule,
        ToastModule,
        TreeModule,
        DropdownModule,
        InputTextareaModule,
        CalendarModule,
        ChartModule,
        AutoCompleteModule,
        InputNumberModule,
        EditorModule,
        RouterModule,
        MessagesModule,
        CardModule,
        OrderListModule,
        ChipsModule,
        SliderModule,
        MultiSelectModule
    ],
    exports: [
        SimpleCardTitleComponent,
        FormsModule,
        ReactiveFormsModule,
        ButtonModule,
        CardModule,
        TableModule,
        InputTextModule,
        PermissionDirective,
        IsSuperUserDirective
    ]
})
export class CoreModule { }